import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Popover,
  MenuItem,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import Iconify from "../components/iconify";
import { del, get } from "src/utils/networkUtils";
import VersusSeasonTypeDialog from "src/components/versus/VersusSeasonTypeDialog";
import VersusSettingsDialog from "src/components/versus/VersusSettingsDialog";
import DeleteDialog from "src/components/leagues-admin/DeleteDialog";
import VersusSeasonTypesTable from "src/components/versus/VersusSeasonTypesTable";
import GameProviderUsersTable from "src/components/stage-admin/GameProviderUsersTable";
import VersusStats from "src/components/versus/VersusStats";
import VersusLineupsTable from "src/components/versus/VersusLineupsTable";
import VersusGamesTable from "src/components/versus/VersusGamesTable";
import WinRatioChart from "src/components/versus/WinRatioChart";
import { useNavigate } from "react-router-dom";
import { getUserPermissions } from "src/utils/permissionsUtils";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}
export default function VersusPage() {
  const navigate = useNavigate();
  const [seasonTypes, setSeasonTypes] = useState([]);
  const [versusStats, setVersusStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [editSeasonType, setEditSeasonType] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteSeasonTypeId, setDeleteSeasonTypeId] = useState(null);
  const [value, setValue] = useState(0);
  const [openSettings, setOpenSettings] = useState(false);
  const { isViewer } = getUserPermissions();

  const handleOpenMenu = (event, id) => {
    setOpen(event.currentTarget);
    setOpenId(id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  useEffect(() => {
    setLoading(true);
    get(`/admin/versus/season-types`).then(function (response) {
      setSeasonTypes(response.versusSeasonTypes);
      setLoading(false);
    });
    get(`/admin/versus/stats`).then(function (response) {
      setVersusStats(response.stats);
      setLoading(false);
    });
  }, []);
  const deleteSeasonTypeHandler = (id) => {
    setLoading(true);
    setOpen(null);
    del(`/admin/versus/season-types/${id}`).then(() => {
      window.location.reload();
    });
  };

  const openDeleteSeasonTypeDialog = (id) => {
    setDeleteSeasonTypeId(id);
    setShowDeleteDialog(true);
  };

  const openEditSeasonTypeDialog = (id) => {
    const seasonType = seasonTypes.find(
      (row) => +row.versusSeasonTypeId === +id
    );
    setEditSeasonType(seasonType);
    setOpen(null);
  };

  const handleViewSeasons = (seasonTypeId) => {
    setOpen(null);
    navigate(`/dashboard/versus/seasons?seasonTypeId=${seasonTypeId}`);
  };

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpenSettings = () => {
    setOpenSettings(true);
  };

  const handleCloseSettings = () => {
    setOpenSettings(false);
  };

  return (
    <>
      <Helmet>
        <title> Versus Game </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h4" gutterBottom>
            Versus Game
          </Typography>
          <Box>
            {!isViewer && (
              <Button
                variant="outlined"
                startIcon={<Iconify icon="eva:settings-2-outline" />}
                onClick={handleOpenSettings}
                sx={{ mr: 1 }}
              >
                Settings
              </Button>
            )}
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:play-circle-outline" />}
              onClick={() => navigate("/dashboard/versus/playground")}
            >
              Playground
            </Button>
          </Box>
        </Stack>

        {versusStats && <VersusStats stats={versusStats} />}

        {versusStats && (
          <Card>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
              >
                <Tab label="Games" {...a11yProps(0)} />
                <Tab label="Top 20 Whales" {...a11yProps(1)} />
                <Tab label="Top 20 Sharps" {...a11yProps(2)} />
                <Tab label="Top 20 Users" {...a11yProps(3)} />
                <Tab label="Lineups" {...a11yProps(4)} />
                <Tab label="Season Types" {...a11yProps(5)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <WinRatioChart title="Wins Ratio" height={300} sx={{ mb: 3 }} />
              <VersusGamesTable
                isActive={value === 0}
                seasonTypes={seasonTypes}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <GameProviderUsersTable rows={versusStats.topLosingUsers} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <GameProviderUsersTable rows={versusStats.topWinningUsers} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <GameProviderUsersTable rows={versusStats.topSpendingUsers} />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <VersusLineupsTable isActive={value === 4} />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <VersusSeasonTypesTable
                rows={seasonTypes}
                loading={loading}
                onMenuOpen={handleOpenMenu}
                onAddNew={() => setEditSeasonType({})}
              />
            </TabPanel>
          </Card>
        )}
      </Container>
      <VersusSeasonTypeDialog
        open={editSeasonType !== null}
        seasonTypeId={editSeasonType?.versusSeasonTypeId}
        onClose={() => setEditSeasonType(null)}
        onSuccessHandler={() => {
          setEditSeasonType(null);
          window.location.reload();
        }}
      />
      <VersusSettingsDialog open={openSettings} onClose={handleCloseSettings} />
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        {!isViewer && (
          <MenuItem onClick={() => openEditSeasonTypeDialog(openId)}>
            <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
            Edit
          </MenuItem>
        )}
        {!isViewer && (
          <MenuItem onClick={() => openDeleteSeasonTypeDialog(openId)}>
            <Iconify icon={"eva:trash-outline"} sx={{ mr: 2 }} />
            Delete
          </MenuItem>
        )}

        <MenuItem onClick={() => handleViewSeasons(openId)}>
          <Iconify icon={"eva:list-fill"} sx={{ mr: 2 }} />
          View Seasons
        </MenuItem>
      </Popover>
      <DeleteDialog
        openConfirm={showDeleteDialog}
        setOpenConfirm={setShowDeleteDialog}
        questionIndex={deleteSeasonTypeId}
        deleteGameHandler={deleteSeasonTypeHandler}
        title={"Delete Season Type"}
        description={"Are you sure you want to delete this Season Type?"}
      />
    </>
  );
}
